<template>
    <div>
      <Helmet>
        <title>Partners Contact - inte-QT</title>
        <meta name="title" content="Partners Contact - inte-QT" />
        <meta name="description" content="For those companies that want to increase their reach." />
        <link rel="canonical" href="https://www.inte-qt.com/contact/partners" />
      </Helmet>
  
      <h1 class="text-center center-header support mx-auto">
        Come and <span class="blue">WIN</span> with us
      </h1>
  
      <form @submit.prevent="sendEmail" ref="partnerForm" class="general__form mx-auto needs-validation">
        <div class="mb-3">
          <input v-model="form.name" type="text" class="form-control" placeholder="Name" name="name" required />
        </div>
  
        <div class="mb-3">
          <input v-model="form.title" type="text" class="form-control" placeholder="Title" name="title" />
        </div>
  
        <div class="mb-3">
          <input v-model="form.company_name" type="text" class="form-control" placeholder="Company Name" name="company_name" required />
        </div>
  
        <div class="mb-3">
          <input v-model="form.website" type="url" class="form-control" placeholder="Website" name="website" required />
        </div>
  
        <div class="mb-3">
          <input v-model="form.email" type="email" class="form-control" placeholder="Email" name="email" required />
        </div>
  
        <div class="mb-3">
          <vue3-tel-input
            v-model="form.phone"
            default-country="US"
            placeholder="Enter phone number"
            class="form-control"
          />
        </div>
  
        <div class="mb-3">
          <select v-model="form.coverage_region" class="form-select" required>
            <option disabled value="">Coverage Region</option>
            <option value="singapore">Singapore</option>
            <option value="malaysia">Malaysia</option>
            <option value="rest-asia">Rest of Asia</option>
            <option value="australia-newzealand">Australia & New Zealand</option>
            <option value="europe">Europe</option>
            <option value="middle-east">Middle East</option>
            <option value="north-america">North America</option>
            <option value="south-america">South America</option>
            <option value="africa">Africa</option>
          </select>
        </div>
  
        <div class="mb-3">
          <select v-model="form.coverage_country" class="form-select" required>
            <option disabled value="">Coverage Country</option>
            <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
          </select>
        </div>
  
        <div class="form-check form-check-inline general__box mb-3">
          <input class="form-check-input" type="checkbox" id="others" v-model="form.multiCountries" />
          <label class="form-check-label" for="others">
            <i class="fas fa-arrow-left blue"></i> Click here for multiple countries.
          </label>
          <textarea class="form-control m-2" rows="3" placeholder="Fill with all the countries" v-model="form.aux1"></textarea>
        </div>
  
        <div class="form-check form-check-inline mb-3 general__box" v-for="(label, key) in offerings" :key="key">
          <input class="form-check-input" type="checkbox" :id="key" :value="label" v-model="form.offering" />
          <label class="form-check-label" :for="key">{{ label }}</label>
        </div>
  
        <div class="form-check form-check-inline general__box mb-3">
          <input class="form-check-input" type="checkbox" v-model="form.othersServiceChecked" />
          <label class="form-check-label">
            <i class="fas fa-arrow-left blue"></i> Click here for other services.
          </label>
          <textarea class="form-control m-2" rows="3" placeholder="Fill with all the services" v-model="form.aux2"></textarea>
        </div>
  
        <div class="mb-3">
          <textarea class="form-control" rows="3" placeholder="Comments" v-model="form.comments"></textarea>
        </div>
  
        <div class="form-check mb-3 general__box">
          <input class="form-check-input" type="checkbox" v-model="form.agree" required />
          <label class="form-check-label">
            Agree to terms and conditions of the
            <router-link to="/privacy-policy">privacy policy</router-link>.
          </label>
        </div>
  
        <div class="text-center">
          <button class="button" type="submit" @click="showAlert">Submit Form</button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import emailjs from 'emailjs-com';
  import Vue3TelInput from 'vue3-tel-input'; 
  import 'vue3-tel-input/dist/vue3-tel-input.css'; 
  import Swal from 'sweetalert2';
  
  export default {
    name: 'PartnersForm',
    components: {
      Vue3TelInput 
    },
    data() {
      return {
        form: {
          name: '',
          title: '',
          company_name: '',
          website: '',
          email: '',
          phone: '',
          coverage_region: '',
          coverage_country: '',
          multiCountries: false,
          aux1: '',
          aux2: '',
          offering: [],
          othersServiceChecked: false,
          comments: '',
          agree: false
        },
        countries: [
          'Singapore', 'Malaysia', 'Indonesia', 'India', 'China', 'Australia',
          'New Zealand', 'USA', 'Canada', 'UK', 'Germany', 'France',
          'Brazil', 'Mexico', 'South Africa', 'Egypt', 'UAE', 'Saudi Arabia'
        ],
        offerings: {
          dia: 'DIA',
          bb: 'Broadband',
          xc: '3G / 4G / 5G / LTE',
          vsat: 'VSAT',
          iptransit: 'IP Transit',
          cpe: 'CPE',
          ms: 'Managed Services'
        }
      };
    },
    methods: {
      sendEmail() {
        if (!this.form.agree) {
          this.showAlert('info', 'You need to agree to the terms and conditions before submitting.');
          return;
        }
  
        emailjs
          .sendForm(
            'service_eqzo3ks',
            'template_ok5amvm',
            this.$refs.partnerForm,
            'sII_fVN7Ct9kkRQpN'
          )
          .then(result => {
            console.log(result.text);
            this.showAlert('success', 'We have received your form. We will review the information and get back to you soon.');
            this.$refs.partnerForm.reset();
          })
          .catch(error => {
            console.log(error.text);
            this.showAlert('error', 'Something went wrong. Please try again later.');
          });
      },
      showAlert(type, message) {
        Swal.fire({
          title: type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Info',
          text: message,
          icon: type,
          timer: 3000,
          timerProgressBar: true
        });
      }
    },
    mounted() {
      window.scrollTo(0, 0);
    }
  };
  </script>
  
  <style scoped>

.general__form {
  max-width: 600px;
  margin: 10px;
  padding: 20px;
  border: 2px solid #007bff; 
  border-radius: 10px; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
}

.text-center {
  text-align: center;
}

.center-header {
  font-size: 2rem;
}

.blue {
  color: blue;
}

.form-check-inline {
  display: inline-block;
}

.form-control {
  width: 100%;
}

button.button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
}

button.button:hover {
  background-color: #0056b3;
}

textarea.form-control {
  resize: vertical;
}

.form-check-label {
  font-size: 0.9rem;
}

.general__box {
  display: table;
  flex-direction: column;
  align-items: flex-start;
}

.mb-3 {
  margin-bottom: 1rem;
}

.form-select {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
}
</style>
  